export default __webpack_public_path__ + "static/media/cert-general2024-cpttm-sc.5af16446.jpg";